export default __webpack_public_path__ + "static/media/telegram-icon.dcd8a777.svg";